import React, { FC } from 'react'

import classes from './logo.module.scss'
import { ReactComponent as LogoIcon } from './logo.svg'

type LogoProps = {
  altText?: string
  dataTestId?: string
}

export const Logo: FC<LogoProps> = ({
  altText = 'Smarty logo - home page',
  dataTestId = 'logo',
}) => (
  <LogoIcon
    aria-label={altText}
    className={classes.image}
    data-testId={dataTestId}
  />
)
